import React from 'react';

import { Row, Col } from 'react-bootstrap';
import SearchInput from 'components/search_sidebar/sidebar_search';
import CompanyOfficeSelect from '../shared/company_office_select';

const height = 42; // Match SearchInput height
type FiltersProps = {
  searchTerm: string;
  onSetSearchTerm: (term: string) => void;
  onSelectOffice: (option: { value: string }) => void;
  officeOptions: Array<{ value: string; label: string }>;
};

const Filters = ({ searchTerm, onSetSearchTerm, onSelectOffice, officeOptions }: FiltersProps) => {
  return (
    <Row className="mb-3">
      <Col xs={6}>
        <label>Search</label>
        <SearchInput
          placeholder="Search by name"
          value={searchTerm}
          onChange={e => onSetSearchTerm(e.target.value)}
          onClear={() => onSetSearchTerm('')}
        />
      </Col>
      <Col xs={6}>
        <label>Office</label>
        <CompanyOfficeSelect
          companyOfficeOptions={officeOptions}
          height={height}
          placeholder="Filter by office"
          onChange={onSelectOffice}
        />
      </Col>
    </Row>
  );
};

export default Filters;
